import { Box, BoxProps } from '@chakra-ui/react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import rehypeHighlight from 'rehype-highlight';
import './prep.scss';

/**
 * Markdown for the prep copilot. Same engine as MarkdownSubtext (react-markdown + remark-gfm +
 * remark-breaks) but styled — via the `.prep-md` class — to also cover the tables, fenced code and
 * headings the copilot produces. Kept SCSS-driven to match the application-assistant pattern.
 */
export function PrepMarkdown({
  children,
  ...boxProps
}: { children: string } & BoxProps) {
  return (
    <Box className="prep-md" {...boxProps}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[
          [rehypeHighlight, { detect: true, ignoreMissing: true }],
        ]}
      >
        {children || ''}
      </ReactMarkdown>
    </Box>
  );
}
